export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'List Your Space',
      description: 'Create a free listing in minutes. Add photos, set your price, and describe what makes your space special.',
      icon: 'ri-add-circle-line',
      color: 'blue'
    },
    {
      number: '02',
      title: 'Get Booked',
      description: 'Renters browse and book your space. You approve requests and communicate through our secure platform.',
      icon: 'ri-calendar-check-line',
      color: 'green'
    },
    {
      number: '03',
      title: 'Earn Money',
      description: 'Get paid securely after each booking. Track your earnings and manage bookings from your dashboard.',
      icon: 'ri-money-dollar-circle-line',
      color: 'purple'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How Stashly Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Start earning from your unused space in three simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-gray-200 z-0" />
              )}
              
              <div className="relative z-10 text-center">
                <div className={`w-32 h-32 mx-auto mb-6 bg-${step.color}-100 rounded-full flex items-center justify-center`}>
                  <i className={`${step.icon} text-5xl text-${step.color}-600`}></i>
                </div>
                <div className="text-6xl font-bold text-gray-200 mb-4">
                  {step.number}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
